var _a, _b;
import { EventSender } from '@libs/analytics/EventSender';
import inViewport from '@resources/js/helpers/inViewport';
const EVENT_NAMES = [
    'check-in-date-click',
    'table-hotel-name-click',
    'faq-shown-listing-page',
];
const EVENTS_CONFIG = {
    'check-in-date-click': { type: 'search-form', category: 'search-form' },
    'table-hotel-name-click': { type: 'table', category: 'table' },
    'faq-shown-listing-page': { type: 'faq', category: 'faq' },
};
// Переходи з лістингу на search page
const SEARCH_REDIRECT_EVENT_NAMES = [
    'search-form-submitted',
    'hotel-card-map-clicked',
    'see-more-clicked',
    'map-view-clicked',
];
const SEARCH_REDIRECT_EVENTS_CATEGORY = 'listing-page-interactions';
const SEARCH_REDIRECT_EVENTS_CONFIG = {
    'search-form-submitted': {
        type: 'search-form-submitted',
        category: SEARCH_REDIRECT_EVENTS_CATEGORY,
    },
    'hotel-card-map-clicked': {
        type: 'hotel-card-map-clicked',
        category: SEARCH_REDIRECT_EVENTS_CATEGORY,
    },
    'see-more-clicked': {
        type: 'see-more-clicked',
        category: SEARCH_REDIRECT_EVENTS_CATEGORY,
    },
    'map-view-clicked': {
        type: 'map-view-clicked',
        category: SEARCH_REDIRECT_EVENTS_CATEGORY,
    },
};
if (((_b = (_a = window.shared) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.cl_id) === 1) {
    const eventSender = new EventSender({
        category: 'post-3-events',
        events: [...EVENT_NAMES],
    });
    const formCheckInEventElement = document.querySelector('.js-event-checkin');
    const tableEventElements = document.querySelectorAll('.js-event-table');
    const faqEventElement = document.querySelector('.js-event-faq');
    formCheckInEventElement === null || formCheckInEventElement === void 0 ? void 0 : formCheckInEventElement.addEventListener('click', () => eventSender.send('check-in-date-click', EVENTS_CONFIG['check-in-date-click']));
    tableEventElements.forEach(el => el.addEventListener('click', () => eventSender.send('table-hotel-name-click', EVENTS_CONFIG['table-hotel-name-click'])));
    inViewport(faqEventElement, () => eventSender.send('faq-shown-listing-page', EVENTS_CONFIG['faq-shown-listing-page']), { rootMargin: '0px' });
    // Івенти переходу з лістингу на search page
    const searchRedirectEventSender = new EventSender({
        category: SEARCH_REDIRECT_EVENTS_CATEGORY,
        events: [...SEARCH_REDIRECT_EVENT_NAMES],
    });
    const hotelMapEventElements = document.querySelectorAll('.js-event-hotel-map');
    const seeMoreEventElement = document.querySelector('.js-event-see-more');
    const mapViewEventElements = document.querySelectorAll('.js-event-map-view');
    document.addEventListener('custom-form-submit', ({ detail }) => searchRedirectEventSender.send('search-form-submitted', Object.assign(Object.assign({}, detail), SEARCH_REDIRECT_EVENTS_CONFIG['search-form-submitted'])));
    hotelMapEventElements.forEach(el => el.addEventListener('click', () => {
        searchRedirectEventSender.send('hotel-card-map-clicked', SEARCH_REDIRECT_EVENTS_CONFIG['hotel-card-map-clicked']);
    }));
    seeMoreEventElement === null || seeMoreEventElement === void 0 ? void 0 : seeMoreEventElement.addEventListener('click', () => searchRedirectEventSender.send('see-more-clicked', SEARCH_REDIRECT_EVENTS_CONFIG['see-more-clicked']));
    mapViewEventElements.forEach(el => el.addEventListener('click', () => searchRedirectEventSender.send('map-view-clicked', SEARCH_REDIRECT_EVENTS_CONFIG['map-view-clicked'])));
}
